
const About = () => {
    return (
        <section id="about" className="about-mf sect-pt4 route">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="box-shadow-full">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-sm-6 col-md-5">
                                            <div className="about-img">
                                                <img src="assets/img/testimonial-2.jpg" className="img-fluid rounded b-shadow-a" alt="" />
                                            </div>
                                        </div>
                                        <div className="col-sm-6 col-md-7">
                                            <div className="about-info">
                                                <p><span className="title-s">Nombre: </span> <span>Mateu Joan Perelló</span></p>
                                                <p><span className="title-s">Perfil: </span> <span>Full stack developer</span></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="skill-mf">
                                        <p className="title-s">Skill</p>

                                        <span>Solidity</span>
                                        <div className="progress">
                                            <div className="progress-bar" role="progressbar" style={{ width: '90%' }} aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                        <span>MySql</span>
                                        <div className="progress">
                                            <div className="progress-bar" role="progressbar" style={{ width: '90%' }} aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                        <span>Java</span>
                                        <div className="progress">
                                            <div className="progress-bar" role="progressbar" style={{ width: '85%' }} aria-valuenow="85" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                        <span>Python</span>
                                        <div className="progress">
                                            <div className="progress-bar" role="progressbar" style={{ width: '85%' }} aria-valuenow="85" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                        <span>Kali Linux</span>
                                        <div className="progress">
                                            <div className="progress-bar" role="progressbar" style={{ width: '80%' }} aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                        <span>Hardhat</span>
                                        <div className="progress">
                                            <div className="progress-bar" role="progressbar" style={{ width: '80%' }} aria-valuenow="80" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                        <span>PostgreSQL</span>
                                        <div className="progress">
                                            <div className="progress-bar" role="progressbar" style={{ width: '70%' }} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                        <span>React</span>
                                        <div className="progress">
                                            <div className="progress-bar" role="progressbar" style={{ width: '70%' }} aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="about-me pt-4 pt-md-0">
                                        <div className="title-box-2">
                                            <h5 className="title-left">
                                                Sobre mi
                                            </h5>
                                        </div>
                                        <p className="lead">
                                            ¡Hola! Soy Mateu Joan Perelló, estudiante de último año de Ingeniería Informática en la Universidad de las
                                            Islas Baleares, con especialización en Sistemas de la Información.
                                        </p>
                                        <p className="lead">
                                            Desde siempre he sentido una gran afinidad por la tecnología, especialmente por la programación.
                                            En estos últimos años, he concentrado mis esfuerzos en el campo de la ciberseguridad, participando en diversos
                                            cursos en línea de hacking ético. Estos cursos me han proporcionado una base sólida,
                                            tanto teórica como práctica, de conocimientos en este campo en constante evolución.
                                            Actualmente estoy comenzando a explorar el mundo de la seguridad en la nube, campo que está llamado a ser el futuro de la ciberseguridad                                        </p>
                                        <p className="lead">
                                            Otra de mis grandes pasiones es la tecnología blockchain. En el año 2021, mientras cursaba mi segundo año de carrera,
                                            descubrí la tecnología blockchain y rápidamente percibí que su potencial va mucho más allá de su uso habitual en ese entonces.
                                            Este interés me ha llevado a leer varios libros sobre el tema, así como a realizar diferentes cursos en los cuales no solo
                                            he adquirido los fundamentos teóricos de la tecnología blockchain, sino también cómo aplicarlos en el mundo real
                                            mediante la creación de aplicaciones descentralizadas.
                                            Esto me ha impulsado a emprender varios proyectos que aprovechan los fundamentos de la tecnología blockchain para su aplicación en diversos campos,
                                            como la trazabilidad de productos de lujo, sector de las energías renovables, el sector inmobiliario y los pagos entre empresas y freelancers sin la necesidad de confiar en ninguna de las partes involucradas.
                                        </p>
                                        <p className="lead">
                                            Actualmente, estoy enfocado en explorar el potencial de la tecnología y los recursos ofrecidos por OpenAI.
                                            Mi objetivo es investigar cómo podemos aprovechar estos recursos para crear aplicaciones innovadoras que no solo faciliten la vida diaria de las personas,
                                            sino que también impulsen la productividad en diversos ámbitos.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default About;